import React, {memo} from "react";

const ContextMenuItemSeparator = () => {
  return <div className="context-menu__item context-menu__item_separator" />;
};

export default memo(ContextMenuItemSeparator);
